const translations = {
    addNewSite: '+ Add a new site',
    all: 'All',
    application: 'Application',
    applicationDate: 'Application Date',
    applicationSite: 'Application Site',
    applicationType: 'Application Type',
    backfillApply: 'Apply',
    backfillConflictMessage:
        'This work order has different values for the fields below. Choose which to keep for each.',
    backfillConflictTitle: 'Update fields from Work Order?',
    backfillCurrentLabel: 'Current value',
    backfillWorkOrderLabel: 'Work order value',
    cancel: 'Cancel',
    carrier: 'Carrier',
    chemicals: 'Chemicals',
    commodity: 'Commodity',
    complete: 'Complete',
    completeReport: 'Complete Report',
    completed: 'Completed',
    confirm: 'Confirm',
    continue: 'Continue',
    continueWithoutWorkOrder: 'Continue without Work Order',
    delete: 'Delete',
    deleteConfirmationMessage: 'Are you sure you want to delete this product usage report?',
    deleteProductUsageReport: 'Delete Product Usage Report',
    downloadPdf: 'Download PDF',
    drone: 'Drone',
    dronePlaceholder: 'Select a drone',
    dryLabel: 'Dry',
    edit: 'Edit',
    emptyNotes: 'No notes have been added to this report.',
    emptyStateAction: 'Add New Product Usage Report',
    emptyStateHeading: "Let's get started by adding a new Product Usage Report",
    endTime: 'End Time',
    epaRegistrationNumber: 'EPA Reg. No.',
    fetchCurrentWeather: 'Fetch Weather',
    fetchingCurrentWeather: 'Fetching…',
    fetchingWeatherCancel: 'OK',
    fetchingWeatherForCurrentLocation:
        'Retrieving weather for your current location as of {{dateTime}}.',
    fetchingWeatherForSelectedSite: 'Retrieving weather for {{siteName}} as of {{dateTime}}.',
    fetchingWeatherFutureDateNote:
        'Application start date is in the future, retrieving weather for the current day instead.',
    fetchingWeatherTitle: 'Fetching Weather Data',
    filterAll: 'All',
    filterCompleted: 'Completed',
    filterPending: 'Pending',
    filterScheduled: 'Scheduled',
    filterStarted: 'Started',
    geolocationPermissionDenied:
        'Location access was denied. Select a site or allow location access to fetch weather.',
    geolocationUnavailable: 'Location services are unavailable. Select a site to fetch weather.',
    gustSpeed: 'Gust Speed',
    humidity: 'Humidity',
    legendCompleted: 'Completed',
    legendPending: 'Pending',
    legendScheduled: 'Scheduled',
    legendStarted: 'Started',
    legendTitle: 'Legend',
    linkWorkOrderPlaceholder: 'Select a work order',
    loading: 'Loading…',
    loadingMessage: 'One moment while we get your list of Product Usage Reports',
    newReport: 'New',
    newReportModalTitle: 'New Product Usage Report',
    noMeasurableWind: 'No measurable wind',
    notAssigned: 'Not assigned',
    notSet: 'Not set',
    notes: 'Notes',
    optionalWorkOrderSubtitle: 'Optionally link a Work Order to this Product Usage Report',
    panelTitle: 'Usage Reports',
    pending: 'Pending',
    product: 'Product',
    products: 'Products',
    proposedAcres: 'Proposed Acres',
    rate: 'Rate',
    reportDetails: 'Report Details',
    reportTitle: 'Product Usage Report',
    save: 'Save',
    saving: 'Saving…',
    scheduled: 'Scheduled',
    searchPlaceholder: 'Search reports…',
    selectWorkOrder: 'Select Work Order (optional)',
    spray: 'Spray',
    startTime: 'Start Time',
    started: 'Started',
    statsPending: 'Pending',
    statsScheduled: 'Scheduled',
    statsStarted: 'Started',
    statsTotal: 'Total',
    submit: 'Submit',
    submitProductUsageReport: 'Submit Product Usage Report',
    submitting: 'Submitting…',
    submittingProductUsageReport: 'Submitting…',
    targetSprayRate: 'Target Spray Rate',
    temperature: 'Temperature',
    timeZone: 'Time Zone',
    totalAcresApplied: 'Total Acres Applied',
    totalApplied: 'Total Applied',
    type: 'Type',
    unitFluidOuncesPerAcre: 'Fl. Oz/Ac',
    unitGallonsPerAcre: 'Ga/Ac',
    unitKilogramsPerSquareMeter: 'Kg/m²',
    unitLitersPerHectare: 'L/Ha',
    unitOuncesPerAcre: 'Oz/Ac',
    unitPintsPerAcre: 'Pt/Ac',
    unitPoundsPerAcre: 'Lb/Ac',
    unitQuartsPerAcre: 'Qt/Ac',
    viewCalendar: 'Calendar',
    viewMap: 'Map',
    weather: 'Weather',
    weatherCapturedAtFirstSite: 'Weather was captured at {{siteName}}.',
    weatherCapturedAtFirstSiteFallback: 'Weather captured at the first selected site.',
    wetLabel: 'Wet',
    windDirection: 'Wind Dir',
    windSpeed: 'Wind Speed',
    workOrder: 'Work Order Name',
    workOrderNumber: 'Work Order Number'
};

export default translations;
